module.exports = __webpack_public_path__ + "static/media/NotoSansThai.31f72506.woff2";